var $class="se2--header-se--sign-in-for-apc",$name="HeaderSE/signInForAPC",$path="app/components/HeaderSE/partials/signInForAPC/config.js",$this={$class,$name,$path,};const popupWidth = 230;
export default popupWidth;
